/* 🤖 this file was generated by script */
export const wiconPhone01 = {
  name: 'phone_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 17.5h.01M8.2 22h7.6c1.12 0 1.68 0 2.1-.22a2 2 0 00.88-.87c.22-.43.22-.99.22-2.11V5.2c0-1.12 0-1.68-.22-2.1a2 2 0 00-.87-.88C17.48 2 16.92 2 15.8 2H8.2c-1.12 0-1.68 0-2.1.22a2 2 0 00-.88.87C5 3.52 5 4.08 5 5.2v13.6c0 1.12 0 1.68.22 2.1.19.38.5.69.87.88.43.22.99.22 2.11.22zm4.3-4.5a.5.5 0 11-1 0 .5.5 0 011 0z"/></svg>`,
};
